import { SupportEmailLink } from "components/app/support-email-link";
import { UpsellBanner } from "components/app/upsell-banner";
import { ContentFull, ContentHeader, ContentSubheader } from "components/layout";
import { InlineBanner } from "components/ui/inline-banner";
import React from "react";
import { useProductName } from "store/selectors/branding";
import { LEAD_SOURCES_DESCRIPTION } from "./lead-source-display";

export const LeadSourcesUpsell: React.FC<unknown> = () => {
    const productName = useProductName();

    return (
        <ContentFull>
            <div className="max-w-3xl">
                <ContentHeader>Lead Sources</ContentHeader>
                <ContentSubheader>{LEAD_SOURCES_DESCRIPTION}</ContentSubheader>
                <UpsellBanner source="lead-sources">
                    <InlineBanner type="info">
                        Lead sources are available to {productName} Premium customers.
                        Contact <SupportEmailLink /> to discuss an upgrade to Premium.
                    </InlineBanner>
                </UpsellBanner>
            </div>
        </ContentFull>
    );
};
